// extracted by mini-css-extract-plugin
export default {"card":"lUvbQ","offset":"nOwTz","title":"e3hrl","description":"v0Lsq"};